import { render, staticRenderFns } from "./FuSearchBar.vue?vue&type=template&id=20f2dece&"
import script from "./FuSearchBar.vue?vue&type=script&lang=js&"
export * from "./FuSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports